import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '@components/common/Layout';
import LandingPage from '@components/pages/LandingPage';
import HospitalDirectory from '@components/pages/HospitalDirectory';
import HospitalDetail from '@components/pages/HospitalDetail';
import HospitalRankings from '@components/pages/HospitalRankings';
import VisaGuide from '@components/pages/VisaGuide';
import MedicalVisaGuide from '@components/pages/MedicalVisaGuide';
import GuidesHub from '@components/pages/GuidesHub';
import ArticleDetail from '@components/pages/ArticleDetail';
import FAQ from '@components/pages/FAQ';
import ServicesPricing from '@components/pages/ServicesPricing';
import ContactUs from '@components/pages/ContactUs';
import SupportConfirmation from '@components/pages/SupportConfirmation';
import MeetingBooking from '@components/pages/MeetingBooking';
import MeetingConfirmation from '@components/pages/MeetingConfirmation';
import SampleGuide from '@components/pages/SampleGuide';
import SuccessPage from '@components/pages/SuccessPage';
import DisclaimerPage from '@components/pages/DisclaimerPage';
import PrivacyPolicyPage from '@components/pages/PrivacyPolicyPage';
import NotFoundPage from '@components/pages/NotFoundPage';
import { usePageView } from '@/hooks/usePageView';
import { useWebVitals } from '@/hooks/useWebVitals';

function AppContent() {
  // Track page views and web vitals (respects cookie consent)
  usePageView();
  useWebVitals();

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/hospitals" element={<HospitalDirectory />} />
        <Route path="/hospitals/:id" element={<HospitalDetail />} />
         <Route path="/hospitals/ranking" element={<HospitalRankings />} />
         <Route path="/visa-guide" element={<VisaGuide />} />
         <Route path="/visa/medical" element={<MedicalVisaGuide />} />
         <Route path="/guides" element={<GuidesHub />} />
         <Route path="/guides/:slug" element={<ArticleDetail />} />
         <Route path="/faq" element={<FAQ />} />
        <Route path="/services" element={<ServicesPricing />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/support-confirmation" element={<SupportConfirmation />} />
        <Route path="/meeting-booking" element={<MeetingBooking />} />
        <Route path="/meeting-confirmation" element={<MeetingConfirmation />} />
        <Route path="/sample-guide" element={<SampleGuide />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
